import { render, staticRenderFns } from "./PgOperator.vue?vue&type=template&id=005ddc2e&scoped=true"
import script from "./PgOperator.vue?vue&type=script&lang=js"
export * from "./PgOperator.vue?vue&type=script&lang=js"
import style0 from "./PgOperator.vue?vue&type=style&index=0&id=005ddc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ddc2e",
  null
  
)

export default component.exports